import React from 'react'
import { connect } from 'react-redux'
import Panel from 'muicss/lib/react/panel'
import Container from 'muicss/lib/react/container'
import RaisedButton from 'material-ui/RaisedButton'
import Form from 'muicss/lib/react/form'
import Col from 'muicss/lib/react/col'
import { TextField } from 'redux-form-material-ui'
import { reduxForm, Field } from 'redux-form'
import { user_not_found } from '../../actions'

const TEXT = `No hemos podido encontrar tu correo en nuestra base de datos.
  Por favor indica a continuación el nombre de la empresa en la que trabajas, 
  y tu correo personal de esta. Asegúrate de no usar tu correo personal, 
  sino el que tu empresa te dio.`

class UserNotFound extends React.Component {

  handleSubmit = values =>
    this.props.user_not_found({ ...values, email: this.props.params.email })

  render() {
    const email = this.props.params.email
    return (
      <Container>
        <Panel className="modal-panel">
          <h1 className="mui--text-center">{email}</h1>
          <br />
          <br />
          <Col md-offset="3" md="6" xs="12">
            <div className="mui--text-justify">
              <p>{ TEXT }</p>
            </div>
          </Col>
          <br />
          <br />
          <Form
            onSubmit={this.props.handleSubmit(this.handleSubmit)}
          >
            <Field
              floatingLabelText="Nombre de tu empresa"
              name="name" label="Nombre de tu empresa"
              component={TextField} fullWidth type="text"
            />
            <Field
              name="comments" label="Comentarios" component={TextField}
              floatingLabelText="Comentarios"
              multiLine rows={10} fullWidth type="text"
            />
            <br />
            <br />
            <RaisedButton
              type="submit" label="Enviar Correo"
              primary style={{ textAlign: 'center' }}
            />
          </Form>
        </Panel>
      </Container>
    )
  }
}

UserNotFound.propTypes = {
  handleSubmit: React.PropTypes.func.isRequired,
  user_not_found: React.PropTypes.func.isRequired,
  params: React.PropTypes.shape({
    email: React.PropTypes.string.isRequired,
  }).isRequired,
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  user_not_found: values => dispatch(user_not_found(values)),
})

const ReduxUserNotFound = connect(
  mapStateToProps, mapDispatchToProps)(UserNotFound)

export default reduxForm({ form: 'UserNotFoundForm' })(ReduxUserNotFound)




// WEBPACK FOOTER //
// ./src/components/UserNotFound/index.jsx